export default "__VITE_ASSET__DZghPj$v__"